module.exports = __webpack_public_path__ + "img/full3-min.7ece462e.png";